module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"donations":"Donations","total_donations":"Total donations","donation_progress":"Donation progress"},"id":{"donations":"Donasi","total_donations":"Jumlah Donasi","donation_progress":"Perkembangan Donasi"}}')
  delete Component.options._Ctor
}
